import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VerifyIconStart } from '@dev/ee-components';
import { Trans, useTranslation } from 'react-i18next';
import { getOnboardingStore } from '@/store/onboarding/actions';
import { OnboardingVideoThumbnail } from '@/components/Onboarding/components/OnboardingVideoThumbnail';
import { push } from 'redux-first-history';
import { SettingsPaths } from '@/services/dictionaries/Paths';
import { Link } from '@material-ui/core';
import { links } from '@/services/dictionaries/links';
import { OnboardingSteps, OnboardingTaskProps } from '../../../types';

const taskId = 'addSendingDomainTask';
const itemVideoId = 'ItZqWf9-DJo';
const singleDomainVerificationPath = SettingsPaths.SingleDomainVerification.replace(':domainName?', '');

export enum AddSendingDomainTaskSavedDataKeysEnum {
    AddDomainSkipStep1 = 'AddDomainSkipStep1',
}

export const useAddSendingDomainTask = ({ onboardingGoals }: OnboardingTaskProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { savedData, data } = useSelector(getOnboardingStore);

    const goToVerifyDomain = (): void => {
        dispatch(push(singleDomainVerificationPath));
    };

    const addSendingDomainSteps: OnboardingSteps = {
        id: taskId,
        title: t('addsendingdomainsteps'),
        items: [
            {
                title: t('validatesendingdomain'),
                features: [t('addsendingdomain_feature1'), t('addsendingdomain_feature2')],
                secondaryContent: <OnboardingVideoThumbnail videoId={itemVideoId} />,
                primaryActionTitle: t('validatedomain'),
                primaryActionCallback: goToVerifyDomain,
                isSkipped: !!savedData?.AddDomainSkipStep1,
                skipSavedDataKey: AddSendingDomainTaskSavedDataKeysEnum.AddDomainSkipStep1,
                isCompleted: data?.ValidatedDomain,
            },
        ],
    };

    return {
        header: t('addsendingdomain'),
        icon: <VerifyIconStart />,
        title: t('addsendingdomain_title'),
        description: (
            <Trans
                i18nKey="addsendingdomain_desc"
                components={{ url: <Link href={links.howToVerifyDomain} target="_blank" /> }}
            />
        ),
        steps: [addSendingDomainSteps],
        activeStepsIndex: 0,
        isVisible:
            onboardingGoals.isConnectingViaAPIAnswered ||
            onboardingGoals.isConnectingViaSMTPAnswered ||
            onboardingGoals.isSendingMarketingEmailsAnswered ||
            onboardingGoals.isSendingTransactionalEmailsAnswered ||
            onboardingGoals.isSendingNewslettersAnswered,
    };
};
